import UnlimitedShortcutBannerCard from './UnlimitedShortcutBannerCard';

export default UnlimitedShortcutBannerCard;
